if (!customElements.get('classroom-banner')) {
  class ClassroomBanner extends HTMLElement {
    constructor() {
      super();
      const raw = this.getAttribute('data-settings');
      this.sectionSettings = raw ? JSON.parse(raw.replaceAll("/'", '"')) : {};
      this.swiper = null;
    }

    connectedCallback() {
      const container = this.querySelector('.classroom-banner__swiper');
      if (!container || typeof Swiper === 'undefined') return;

      const slides = container.querySelectorAll('.swiper-slide');
      if (slides.length < 2) return;

      const autoplaySpeed = Number(this.sectionSettings.autoplay_speed) || 0;

      this.swiper = new Swiper(container, {
        loop: Boolean(this.sectionSettings.loop),
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        autoplay:
          autoplaySpeed > 0
            ? {
                delay: autoplaySpeed * 1000,
                pauseOnMouseEnter: Boolean(this.sectionSettings.pause_on_hover),
              }
            : false,
        pagination: {
          el: container.querySelector('.classroom-banner__pagination'),
          clickable: true,
        },
      });

      if (
        this.sectionSettings.pause_on_hover &&
        autoplaySpeed > 0 &&
        this.swiper.autoplay
      ) {
        container.addEventListener('mouseenter', () => this.swiper.autoplay.stop());
        container.addEventListener('mouseleave', () => this.swiper.autoplay.start());
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('classroom-banner', ClassroomBanner);
}
